import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const BridgeStateContext = createContext();

export function BridgeStateProvider({ children }) {
  const [options, setOptions] = useState({});
  const [incomingMessage, setIncomingMessage] = useState({});

  // Handles incoming messages from the native bridge
  const handleBridgeMessage = useCallback((json) => {
    try {
      const data = JSON.parse(json);
      if (data.type && data.type === 'appSettings') {
        setOptions((prev) => (data));
      }
      if (data.type && data.type === 'chatMessage') {
        setIncomingMessage((prev) => (data));
      }
    } catch (e) {
      console.error("Failed to parse bridge message JSON:", e);
    }
  }, []);

  useEffect(() => {
    // Set up the bridge handler
    window.shellJsBridgeNativeToWeb = {
      onMessage: handleBridgeMessage,
    };
    window.shellJsBridgeNativeToWebQueue = window.shellJsBridgeNativeToWebQueue || [];

    // Process any queued messages
    function processQueuedMessages() {
      while (window.shellJsBridgeNativeToWebQueue.length > 0) {
        const json = window.shellJsBridgeNativeToWebQueue.shift();
        handleBridgeMessage(json);
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", processQueuedMessages);
    } else {
      processQueuedMessages();
    }
  }, [handleBridgeMessage]);

  return (
    <BridgeStateContext.Provider value={{ options, incomingMessage }}>
      {children}
    </BridgeStateContext.Provider>
  );
}


export function useBridgeOptions() {
  return useContext(BridgeStateContext).options;
}

export function useBridgeIncomingMessage() {
  return useContext(BridgeStateContext).incomingMessage;
}


// React hook to listen for bridge language changes and call a callback
export function useNativeLanguageListener(callback) {
  const bridgeOptions = useBridgeOptions();
  const prevLangRef = React.useRef();

  useEffect(() => {
    if (bridgeOptions && bridgeOptions.language && bridgeOptions.language !== prevLangRef.current) {
      prevLangRef.current = bridgeOptions.language;
      callback(bridgeOptions.language);
    }
  }, [bridgeOptions, callback]);
}
